import { render, staticRenderFns } from "./MotorSelectorScorecard.vue?vue&type=template&id=7143f052&scoped=true&"
import script from "./MotorSelectorScorecard.vue?vue&type=script&lang=js&"
export * from "./MotorSelectorScorecard.vue?vue&type=script&lang=js&"
import style0 from "./MotorSelectorScorecard.vue?vue&type=style&index=0&id=7143f052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7143f052",
  null
  
)

export default component.exports